__turbopack_context__.v({
  "message": "free-shipping-progress-module-scss-module__6IGCYW__message",
  "progress": "free-shipping-progress-module-scss-module__6IGCYW__progress",
  "progressContainer": "free-shipping-progress-module-scss-module__6IGCYW__progressContainer",
  "root": "free-shipping-progress-module-scss-module__6IGCYW__root",
  "u-animation-bounce": "free-shipping-progress-module-scss-module__6IGCYW__u-animation-bounce",
});
